var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[(_vm.showSubBox)?_c('b-row',[_c('b-col',[_c('subscribe-box')],1)],1):_vm._e(),_c('b-row',[_c('b-col',[_c('network-list',{attrs:{"networks":_vm.networks,"regions":_vm.regions}})],1)],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }